/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import useClickStreamCustomEventsTracking from '../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import { setLongerPassportMessageSalesForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import { getLongerPassportMessageSFABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const LongerPassportMessageABTest = ({ pageType }) => {
    const dispatchAction = useDispatch();
    const longerPassportMessageABTestData = useSelector((state) => state?.mfeCheckout.app?.abTest?.longerPassportMessage || {});

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'Nonmembers-Checkout-Longer Passport Message-v1',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
    });

    /* Start Code AB Testing */
    useClickStreamCustomEventsTracking({
        salesforceResponse: data?.contentSF,
        isFireImpression: !!data?.contentSF,
        page: { type: pageType },
    });

    if ((loading) || (!loading && !data && !error)) {
        return <></>;
    }

    if (error) {
        mbpLogger.logError({
            function: 'LongerPassportMessage',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Passport Longer Message Salesforce AB test returned an error',
            jsError: error,
        });
    }

    const campaignResponses = data?.contentSF?.campaign?.campaignResponses?.[0] || {};
    if (
        campaignResponses.userGroup
        && campaignResponses.userGroup !== longerPassportMessageABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        dispatchAction(setLongerPassportMessageSalesForceABTest(data.contentSF));
        dispatchAction(trackEvent({
            eventName: 'feature_experiment',
            eventCategory: 'Experiment',
            eventAction: 'Longer Passport Message',
            eventLabel: campaignResponses.userGroup === 'Default' ? 'Variant' : 'Control',
        }));
    }

    return <></>;
};

LongerPassportMessageABTest.propTypes = {
    pageType: string.isRequired,
};

export default LongerPassportMessageABTest;
